 <template>
  <div class="thumbs" :id="channelSlug">
    <figure v-for="block in blocks" :key="block.id" :id="block.id + '-figure'" >

      <template v-if="block.image">
        <!-- lazyload images using 'vue-lazyload' -->

        <div :id="block.id" v-if="isMobile==true && block.source && block.source.provider && (block.source.provider.name == 'Vimeo' || block.source.provider.name == 'YouTube')" v-html="block.embed.html">
        </div>

        <div ref="enlarged" class="main-element instagram-enlarged-container" v-else-if="isMobile==true && !block.embed && block.source">
          <img class="enlarged" :id="block.id" :src="block.image.large.url" v-on:click="enlargeVimeo" />
          <a :href="block.source.url" target="_blank">
            <svg class="instagram-logo enlarged" fill="#ffffff" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" width="48px" height="48px">    <path d="M 8 3 C 5.243 3 3 5.243 3 8 L 3 16 C 3 18.757 5.243 21 8 21 L 16 21 C 18.757 21 21 18.757 21 16 L 21 8 C 21 5.243 18.757 3 16 3 L 8 3 z M 8 5 L 16 5 C 17.654 5 19 6.346 19 8 L 19 16 C 19 17.654 17.654 19 16 19 L 8 19 C 6.346 19 5 17.654 5 16 L 5 8 C 5 6.346 6.346 5 8 5 z M 17 6 A 1 1 0 0 0 16 7 A 1 1 0 0 0 17 8 A 1 1 0 0 0 18 7 A 1 1 0 0 0 17 6 z M 12 7 C 9.243 7 7 9.243 7 12 C 7 14.757 9.243 17 12 17 C 14.757 17 17 14.757 17 12 C 17 9.243 14.757 7 12 7 z M 12 9 C 13.654 9 15 10.346 15 12 C 15 13.654 13.654 15 12 15 C 10.346 15 9 13.654 9 12 C 9 10.346 10.346 9 12 9 z"/></svg>
          </a>
        </div>

        <img class="enlarged" :id="block.id" v-else-if="isMobile==true" v-lazy="block.image.large.url" />

        <!-- Regular image block -->
        <img ref="thumbnail" :id="block.id" class="main-element" v-else-if="isThumb==true && !block.embed && !block.source" v-lazy="block.image.thumb.url" v-on:click="enlargeVimeo">

        <!-- Instagram block -->
        <div class="instagram-thumb-container main-element" v-else-if="isThumb==true && !block.embed && block.source && block.source.provider && (block.source.provider.name == 'Instagram')">
          <img ref="thumbnail" :id="block.id" v-lazy="block.image.thumb.url" v-on:click="enlargeVimeo">
          <a :href="block.source.url" target="_blank">
            <svg class="instagram-logo" fill="#ffffff" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" width="48px" height="48px">    <path d="M 8 3 C 5.243 3 3 5.243 3 8 L 3 16 C 3 18.757 5.243 21 8 21 L 16 21 C 18.757 21 21 18.757 21 16 L 21 8 C 21 5.243 18.757 3 16 3 L 8 3 z M 8 5 L 16 5 C 17.654 5 19 6.346 19 8 L 19 16 C 19 17.654 17.654 19 16 19 L 8 19 C 6.346 19 5 17.654 5 16 L 5 8 C 5 6.346 6.346 5 8 5 z M 17 6 A 1 1 0 0 0 16 7 A 1 1 0 0 0 17 8 A 1 1 0 0 0 18 7 A 1 1 0 0 0 17 6 z M 12 7 C 9.243 7 7 9.243 7 12 C 7 14.757 9.243 17 12 17 C 14.757 17 17 14.757 17 12 C 17 9.243 14.757 7 12 7 z M 12 9 C 13.654 9 15 10.346 15 12 C 15 13.654 13.654 15 12 15 C 10.346 15 9 13.654 9 12 C 9 10.346 10.346 9 12 9 z"/></svg>
          </a>
        </div>

        <!-- Other blocks with source -->
        <div class="instagram-thumb-container main-element" v-else-if="isThumb==true && !block.embed && block.source">
          <img ref="thumbnail" :id="block.id" v-lazy="block.image.thumb.url" v-on:click="enlargeVimeo">
        </div>

        <!-- Vimeo & Youtube block -->
        <div class="vimeo-thumb-container main-element" v-else-if="isThumb==true && block.source && block.source.provider && (block.source.provider.name == 'Vimeo' || block.source.provider.name == 'YouTube')">
          <img ref="thumbnail" :id="block.id" class="vimeo-thumb" v-lazy="block.image.thumb.url" v-on:click="enlargeVimeo">
          <div class="play-button"></div>
        </div>

        <img ref="enlarged" class="enlarged main-element" :id="block.id" v-else-if="isThumb==false && !block.embed && !block.source" :src="block.image.large.url" v-on:click="enlargeVimeo" />

        <div ref="enlarged" class="main-element instagram-enlarged-container" v-else-if="isThumb==false && !block.embed && block.source && block.source.provider && (block.source.provider.name == 'Instagram')">
          <img class="enlarged" :id="block.id"  :src="block.image.large.url" v-on:click="enlargeVimeo" />
          <a :href="block.source.url" target="_blank">
            <svg class="instagram-logo enlarged" fill="#ffffff" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" width="48px" height="48px">    <path d="M 8 3 C 5.243 3 3 5.243 3 8 L 3 16 C 3 18.757 5.243 21 8 21 L 16 21 C 18.757 21 21 18.757 21 16 L 21 8 C 21 5.243 18.757 3 16 3 L 8 3 z M 8 5 L 16 5 C 17.654 5 19 6.346 19 8 L 19 16 C 19 17.654 17.654 19 16 19 L 8 19 C 6.346 19 5 17.654 5 16 L 5 8 C 5 6.346 6.346 5 8 5 z M 17 6 A 1 1 0 0 0 16 7 A 1 1 0 0 0 17 8 A 1 1 0 0 0 18 7 A 1 1 0 0 0 17 6 z M 12 7 C 9.243 7 7 9.243 7 12 C 7 14.757 9.243 17 12 17 C 14.757 17 17 14.757 17 12 C 17 9.243 14.757 7 12 7 z M 12 9 C 13.654 9 15 10.346 15 12 C 15 13.654 13.654 15 12 15 C 10.346 15 9 13.654 9 12 C 9 10.346 10.346 9 12 9 z"/></svg>
          </a>
        </div>

        <div ref="enlarged" class="main-element instagram-enlarged-container" v-else-if="isThumb==false && !block.embed && block.source">
          <img class="enlarged" :id="block.id"  :src="block.image.large.url" v-on:click="enlargeVimeo" />
        </div>

        <div ref="enlarged" class="vimeo-container main-element" :id="block.id" v-else-if="isThumb==false && block.source && block.source.provider && (block.source.provider.name == 'Vimeo' || block.source.provider.name == 'YouTube')" v-on:click="enlargeVimeo" v-html="block.embed.html">
        </div>

        <!-- Regular image -->
        <p class="link" v-if="isThumb==false && !block.embed && !block.source">{{block.description}} {{block.description ? "|" : ""}} <a :href="block.image.original.url" target="_blank">download high res</a></p>
        <!-- Instagram embed -->
        <p class="link" v-else-if="isThumb==false && !block.embed && block.source">{{block.description}} | <a :href="block.source.url" target="_blank">view on {{block.source.provider.name}}</a></p>
        <!-- Youtube / Vimeo embed -->
        <p class="link" v-else-if="isThumb==false && block.embed && block.source">{{block.source.title}} | <a :href="block.source.url" target="_blank">watch on {{block.source.provider.name}}</a></p>
      </template>

      <template v-else-if="block.content">
        <p class="arena-text" v-html="block.content_html"></p>
      </template>

      <template v-else>
        <p v-if="block.class !== 'Channel'">{{block.title}}</p>
        <p v-else>Loading... </p>
      </template>

    </figure>

  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import $ from 'jquery'

export default {
  name: 'ArenaChannel--Thumbs',
  components: {

  },
  props: {
    channelSlug: { type: String, required: true }, // slug of channel to query
    blockTypes: { type: Array, default: () => [] }, // filter by block.class, e.g. ['Image']
    textFilter: { type: String, default: '' } // filter by text
  },
  data () {
    return {
      loading: true,
      channel: [],
      currentPosY: 0,
      isThumb: true,
      channelTop: 0,
      isMobile: false
    }
  },
  computed: {
    blocks () {
      /**
      * Function to filter blocks from channel contents, based on block.class
      * Filters further by title if active filter
      **/
      const types = this.blockTypes
      const filter = this.textFilter
      const chnnl = !types.length ? this.channel : this.channel.filter(items => types.includes(items.class))
      const blks = chnnl.slice().reverse() // clone and reverse array (so .reverse() doesn't mutate this.channel)
      // output
      if (!filter) return blks
      return blks.filter(image => {
        const regex = new RegExp(filter, 'gmi')
        return regex.exec(image.title)
      })
    }
  },
  methods: {
    // functions from store.js to use in this component
    ...mapActions(['getChannel']),

    async getContents (slug, page = 1) {
      /**
       * Function to get all contents of an arena channel
       * If has more blocks than maxPageSize (100), calls next page recursively
      **/
      let args = { id: slug, params: { page: page, per: 100 } }
      return this.getChannel(args).then(async contents => {
        // add blocks to list
        this.channel.push(...contents)
        // get subchannels
        const subs = contents.filter(blk => blk.class === 'Channel')
        // loop through each channel
        for (let channel of subs) {
          // position of subchanel block
          const index = this.channel.findIndex(item => item.slug === channel.slug)
          try {
            // "await" ensures next channel isn't called and inserted before current one (to block maintain order)
            await this.getSubchannel(channel.slug, 1, index)
          } catch (err) {
            console.error('Error getting Subchannel contents', err)
          }
        }
        // get next page
        if (contents.length === args.params.per) {
          return this.getContents(slug, page + 1)
        }

        console.log('test: ', this.channel)
        // end
        this.loading = false
      })
    },
    async getSubchannel (slug, page = 1, index) {
      /**
       * Function for getting and inserting subchannel content
      **/
      let args = { id: slug, params: { page: page, per: 100 } }
      return this.getChannel(args).then(children => {
        // replace subchannel block with it's children
        this.channel.splice(index, 1, ...children)
        // next page
        if (children.length === args.params.per) {
          return this.getSubchannel(slug, page + 1, index + children.length)
        }
        // end
      })
    },
    enlargeVimeo: function (event) {
      let currentChannel = '#' + this.channelSlug + ' .main-element'
      const isEnlarged = (!this.$refs.thumbnail || this.$refs.thumbnail.length === 0)

      if (isEnlarged) {
        $(currentChannel).removeClass('a')
        $(currentChannel + ' img').removeClass('a')
        this.isThumb = true
        $('html,body').scrollTop(0)
        $(currentChannel).css('height', '180px')
        $(currentChannel).css('width', 'auto')
        $(currentChannel + ' img').css('height', '180px')
        $(currentChannel + ' img').css('width', 'auto')
        $(currentChannel).css('margin', '3px')
        $(currentChannel).css('cursor', 'zoom-in')
        $('#' + this.channelSlug).css('padding', '20px 20px')
        $('.arena-text').css('padding', '0')
        $('html,body').scrollTop(this.currentPosY)
      } else {
        $(currentChannel).css('width', '100%')
        $(currentChannel).css('height', 'auto')

        this.currentPosY = this.getCurrentY()
        let array, index
        array = this.$refs.thumbnail
        index = array.findIndex(obj => obj.id === event.currentTarget.id)

        $(currentChannel).addClass('a')
        $(currentChannel + ' img').addClass('a')
        $(currentChannel + ' img').css('width', '100%')
        $(currentChannel + ' img').css('height', 'auto')
        $(currentChannel + ' img').css('cursor', 'zoom-out')
        $(currentChannel + ' div').css('width', '100%')
        $(currentChannel + ' div').css('height', '100%')
        $(currentChannel).css('cursor', 'zoom-out')
        $(currentChannel).css('margin', '0')
        $(currentChannel).css('padding', '0')
        $('.arena-text').css('padding', ' 20px 20px')

        this.isThumb = false

        Vue.nextTick(() => {
          $('iframe').css('position', 'absolute')
          $('iframe').css('top', '0')
          $('iframe').css('left', '0')
          $('iframe').css('right', '0')
          $('iframe').css('bottom', '0')
          $('iframe').css('width', '100%')
          $('iframe').css('height', '100%')
          $('iframe').css('cursor', 'zoom-out')
          $('html,body').scrollTop(this.$refs.enlarged[index].offsetTop)
        })
      }
    },
    getCurrentY: function () {
      return window.scrollY
    },
    detectMobile: function () {
      console.log('detect mobile')
      if ($(window).width() < 600) {
        this.isMobile = true
        this.isThumb = false
      }

      // console.log(this.isMobile)

      return this.isMobile
    },
    adjustMobileIFrames: function () {
      if (this.isMobile) {
        setTimeout(() => {
          $('iframe').css('width', '100%')
          $('iframe').css('height', '350px')
          $('iframe').css('background-color', 'lightgray')
        }, 200)
      }
    }
  },
  created () {
    if ($(window).width() < 600) {
      this.isMobile = true
      this.isThumb = false
    }

    this.getContents(this.channelSlug).then(() => {
      this.adjustMobileIFrames()
    })
    // window.addEventListener('load', this.detectMobile)
    // window.addEventListener('scroll', this.getCurrentY)
  },
  destroyed () {
    // window.addEventListener('load', this.detectMobile)
    // window.addEventListener('scroll', this.getCurrentY)
  },
  showLightbox: function (imageName) {
    this.$refs.lightbox.show(imageName)
  }

}

</script>

<style scoped>
div{
  width:100%;
  /* display:flex;
  flex-wrap: wrap; */
}

.thumbs{
  padding:20px 20px;
}

.container {
    position: relative;
    overflow: hidden;
    padding-top: 56.25%;
}

.vimeo-thumb {
  /* max-height: 100vh !important; */
}

.vimeo-container {
  height: 100vh;
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  margin: 5px 0;
  padding-top: 56.25%;
}

.vimeo-thumb-container {
  position: relative;
  display: inline;
}

.instagram-thumb-container {
  position: relative;
  display: inline;
}

.play-button {
  position: absolute;
  top: 0;
  left: 50%;
  width: 25px;
  height: 25px;
  transform: translateX(-45%) translateY(-220%);
  border-style: solid;
  border-width: 1.25em 0em 1.25em 2.5em;
  border-color: transparent transparent transparent #fff;
  opacity: 0.65;
  pointer-events: none;
}

.container:hover{
  cursor:zoom-out;
    opacity:1;
}

.instagram {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width:52%;
    border: 0;
    -webkit-transform: translateX(-50%) ;
    -moz-transform: translateX(-50%) ;
    transform: translateX(50%) ;
}

.embedly-embed {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width:52%;
    border: 0;
    -webkit-transform: translateX(-50%) ;
    -moz-transform: translateX(-50%) ;
    transform: translateX(50%) ;
}

figure {
 /* outline:1px solid #ccc;*/
  /*flex: 0 10%;*/
  display: inline;
  /* display:flex;
  justify-content: center;
  align-items: center; */
  & img{
    margin:3px;
    box-shadow: 3px 3px 8px #ddd;
    height:180px;
    float: left;
  }
  & a{
    cursor: zoom-in;
    text-decoration: underline;
  }
  & a:hover {
    opacity: 0.7;
  }
}

.instagram-enlarged-container {
  position: relative;
}

.instagram-logo {
  position: absolute;
  top: 0;
  right: 0;
  margin-top: -176px;
  opacity: 0.6;
  width: 30px;
  margin-right: 3px;

  &.enlarged {
    margin-top: 0;
  }
}

  .link{
    text-align: center;
    font-size: 13px;
    padding-bottom: 15px;
  }

  img:hover{
    cursor:zoom-in;
    opacity:0.5;
  }

  .a:hover{
    cursor:zoom-out;
    opacity:1;
  }

  a:hover{
    cursor:pointer
  }

img.enlarged {
  width: 100%;
  height: auto;

  &:hover {
    opacity: 1;
    cursor: zoom-out;
  }
}

.arena-text {
  float: left;
  display:block;
  width:100%;
  padding:0;
  text-align: center;
  font-size: 1em;
  border-top: 1px solid #ddd;
  margin-top: 10px;
}

@media only screen and (max-width: 500px) {
  figure{
  & img{
    margin:3px;
    width:100%;
    height:auto;
    box-shadow: 0px 0px 0px #ddd;
  }
  }

  img:hover{
    cursor:unset;
    opacity:1;
  }

}

</style>
